// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-modal__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: var(--space-quarter) calc( var(--space-x3) + var(--space-half) ) var(--space-and-half) calc( var(--space-x3) + var(--space-half) );
}

.login-modal__container .login-modal__icon {
    color: var(--new-green-color);
    font-size: var(--space-x3);
}

.login-modal-title.baloa-headline-2 {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-bold);
    font-size: calc( var(--space-and-half) + var(--space-eighth) );
    line-height: calc( var(--space-and-half) + var(--space-quarter) + 1px );
    margin: var(--space-and-half) 0;
    text-align: center;
}

.login-modal-text.baloa-names {
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
    margin-bottom: var(--space-and-half);
    text-align: center;
}

.login-modal-actions,
.login-modal-actions .secondary-button,
.login-modal-actions .primary-button {
    width: 100%;
}

.login-modal__container .hubicon-pages,
.login-modal__container .hubicon-groups,
.login-modal__container .hubicon-create_team,
.login-modal__container .hubicon-join_team {
    font-size: var(--space-x3);
}

.login-modal__icon.hubicon-add_option{
    font-size: calc( var(--space) + var(--space-quarter) );
    padding: var(--space-half-quarter);
    border-radius: 50%;
    background-color: var(--new-green-color);
    color: var(--white-color);
}

.login-modal__icon.author.icon-user {
    border: 5px solid var(--new-green-color);
    color: var(--new-green-color);
    font-size: var(--space-x3);
    border-radius: 50%;
}

.login-modal__icon.icon-trophy.staff-invitation{
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--white-color);
    background-color: var(--new-yellow-color);
    border-radius: 50%;
    font-size: 40px;
    width: 60px;
    height: 60px;
}

.login-modal__icon.hubicon-play_circle::before {
    color: var(--new-green-color);
    font-size: 54px;
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/components/login-modal/LoginModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,0IAA0I;AAC9I;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;IACrC,6BAA6B;IAC7B,8DAA8D;IAC9D,uEAAuE;IACvE,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;;;IAGI,WAAW;AACf;;AAEA;;;;IAII,0BAA0B;AAC9B;;AAEA;IACI,sDAAsD;IACtD,kCAAkC;IAClC,kBAAkB;IAClB,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,6BAA6B;IAC7B,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,yCAAyC;IACzC,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB","sourcesContent":[".login-modal__container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: var(--space-quarter) calc( var(--space-x3) + var(--space-half) ) var(--space-and-half) calc( var(--space-x3) + var(--space-half) );\n}\n\n.login-modal__container .login-modal__icon {\n    color: var(--new-green-color);\n    font-size: var(--space-x3);\n}\n\n.login-modal-title.baloa-headline-2 {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-bold);\n    font-size: calc( var(--space-and-half) + var(--space-eighth) );\n    line-height: calc( var(--space-and-half) + var(--space-quarter) + 1px );\n    margin: var(--space-and-half) 0;\n    text-align: center;\n}\n\n.login-modal-text.baloa-names {\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n    margin-bottom: var(--space-and-half);\n    text-align: center;\n}\n\n.login-modal-actions,\n.login-modal-actions .secondary-button,\n.login-modal-actions .primary-button {\n    width: 100%;\n}\n\n.login-modal__container .hubicon-pages,\n.login-modal__container .hubicon-groups,\n.login-modal__container .hubicon-create_team,\n.login-modal__container .hubicon-join_team {\n    font-size: var(--space-x3);\n}\n\n.login-modal__icon.hubicon-add_option{\n    font-size: calc( var(--space) + var(--space-quarter) );\n    padding: var(--space-half-quarter);\n    border-radius: 50%;\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n\n.login-modal__icon.author.icon-user {\n    border: 5px solid var(--new-green-color);\n    color: var(--new-green-color);\n    font-size: var(--space-x3);\n    border-radius: 50%;\n}\n\n.login-modal__icon.icon-trophy.staff-invitation{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--white-color);\n    background-color: var(--new-yellow-color);\n    border-radius: 50%;\n    font-size: 40px;\n    width: 60px;\n    height: 60px;\n}\n\n.login-modal__icon.hubicon-play_circle::before {\n    color: var(--new-green-color);\n    font-size: 54px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
